<div class="login-form-flex">
    <mat-card appearance="outlined" class="single">
        <mat-card-header>
            <mat-card-title class="header">{{ translateBase + 'title' | translate }}</mat-card-title>
        </mat-card-header>
        <form [formGroup]="mfaForm" (ngSubmit)="submit()">
            <mat-card-content>
                @if (qrImage) {
                    <div class="form-group qr">
                        <img [src]="qrImage" alt="">
                    </div>
                }
                <p class="secondary-body-text">{{ translateBase + 'text' | translate }}</p>
                <mat-form-field class="field">
                    <mat-label>{{ 'login.mfa.code' | translate }}</mat-label>
                    <input matInput #totpCodeInput
                           required
                           type="text"
                           id="totpCodeInput"
                           formControlName="mfaCode"
                           class="form-control"
                           [attr.disabled]=""
                           cdkFocusInitial>
                </mat-form-field>
                <div class="error-text error-placeholder">
                    @if (waitingForResponse) {
                        <span>{{ 'login.mfa.waiting' | translate }}</span>
                    }
                    @if (error) {
                        <span>{{ 'login.mfa.error' | translate }}</span>
                    }
                </div>
            </mat-card-content>
            <mat-card-actions class="centered-button-container">
                <div class="button-flex-container">
                    <button mat-raised-button autofocus color="primary" type="submit"
                            [disabled]="waitingForResponse || completed"
                            class="btn-navigation">
                        {{ 'buttons.send' | translate }}
                    </button>
                    <br/><br/>
                    <button mat-button (keypress)="logout()" (click)="logout()">
                        {{ 'login.mfa.logout' | translate }}
                    </button>
                </div>
            </mat-card-actions>
        </form>
    </mat-card>
</div>
